import React, { FC } from 'react';
import { Button, ButtonProps, CircularProgress } from '@mui/material';
import { Download } from '@mui/icons-material';

type DownloadExportButtonProps = Omit<ButtonProps, 'onClick' | 'startIcon' | 'children'> & {
    label: string;
    isLoading: boolean;
    onDownload: () => void;
};

/**
 * Trigger for a server-built CSV export: shows a spinner while the file is being
 * generated and refuses a second click until the first download has finished.
 */
const DownloadExportButton: FC<DownloadExportButtonProps> = ({
    label,
    isLoading,
    onDownload,
    disabled,
    ...buttonProps
}: DownloadExportButtonProps) => (
    <Button
        variant="outlined"
        {...buttonProps}
        startIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : <Download />}
        onClick={onDownload}
        disabled={disabled || isLoading}
        aria-label={label}
    >
        {label}
    </Button>
);

export default DownloadExportButton;
